import { StyleDeclaration, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { FormFieldType, IFormField } from '../../../extViewmodels';
import { ISelectOption } from '../../../web/components/DeprecatedSelect';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../web/components-v2/Select';
import { IFormFieldOption } from '../../viewModels/form';
import { styleSheet } from './styles';

export type SelectedDecisionMaker = ISelectOption<IFormField<IFormFieldOption>>;

interface IProps {
	className?: string;
	DecisionMakerSelectStyles?: StyleDeclaration[];
	decisionMaker?: string;

	selected: SelectedDecisionMaker;
	onSelect: (value: SelectedDecisionMaker) => void;
}

const noneAndCustomOptions = [
	{
		dataContext: {
			fieldType: FormFieldType.Custom,
			label: 'Decision Maker',
			name: 'Decision Maker',
		},
		id: 'decisionMaker',
		text: 'Decision Maker',
	},
	{
		dataContext: {
			fieldType: FormFieldType.Custom,
			label: 'Influencer',
			name: 'Influencer',
		},
		id: 'influencer',
		text: 'Influencer',
	},
	{
		dataContext: {
			fieldType: FormFieldType.Custom,
			label: 'Other',
			name: 'Other',
		},
		id: 'other',
		text: 'Other',
	},
];

const DecisionMakerSelectBase: React.FC<IProps> = ({
	className = 'decisionMaker',
	DecisionMakerSelectStyles = [],

	selected,
	onSelect,
}) => {
	const [selectedOption, setSelectedOption] = useState<SelectedDecisionMaker>(null);

	useEffect(() => {
		setSelectedOption(selected);
	}, [selected]);

	return (
		<div className={`${css(styleSheet.DecisionMakerSelectContainer)} ${className}`}>
			<div className={`decision-maker-label ${css(styleSheet.label)}`} />
			<div className={css(styleSheet.selectContainer, ...DecisionMakerSelectStyles)}>
				<Select
					value={selectedOption?.id ?? ''}
					onValueChange={value => {
						const option = noneAndCustomOptions.find(o => o.id === value);
						if (option) onSelect(option);
					}}
				>
					<SelectTrigger styles={styleSheet.trigger}>
						<div className={`follow-up-title ${css(styleSheet.title)}`}>
							{selectedOption ? (
								<span className={css(styleSheet.selectedOptionText)}>{selectedOption.text}</span>
							) : (
								<span>Other</span>
							)}
						</div>
					</SelectTrigger>
					<SelectContent styles={styleSheet.dropdown}>
						{noneAndCustomOptions.map(option => (
							<SelectItem key={option.id} value={option.id}>
								{option.text}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		</div>
	);
};

export const DecisionMakerSelect = observer(DecisionMakerSelectBase);
